export default __webpack_public_path__ + "media/images/manual/ic/09-011906e5f6ec2456ef8f45c728a629d0.png";